import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import configureStore from './store/configureStore';
import '@fluentui/react/dist/css/fabric.css';
import 'react-toastify/dist/ReactToastify.css';
import './styles/index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { datadogLogs } from '@datadog/browser-logs';
import { moduleBrokerName, moduleEnableSubscription } from './module-params';

console.log(`
-----------------------------
📊 BROKER CONFIGURATION
-----------------------------
🔹 Broker Name         : ${moduleBrokerName || ''}
🔹 Subscription Module: ${moduleEnableSubscription ? '✅ Yes' : '❌ No'}
-----------------------------
`);

const { REACT_APP_DATADOG_CLIENT_TOKEN = '' } = process.env;

if (REACT_APP_DATADOG_CLIENT_TOKEN) {
  console.log('datadogLogs enabled');

  datadogLogs.init({
    clientToken: REACT_APP_DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.eu',
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
  });
}

const store = configureStore();

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
